// utils/flattenForSearch.ts
export function flattenForSearch(value: unknown): string {
  if (value == null) return ''
  if (Array.isArray(value)) return value.map(flattenForSearch).join(' ')
  if (typeof value === 'object') return Object.values(value).map(flattenForSearch).join(' ')
  return String(value)
}
